
<template>
 
        <button  
                type="button"
                :disabled="!FinalEnabled"

                :m_AttributeEnabled="m_Attribute.Enabled+''"
                v-show="FinalVisible"
                @click="OnButtonClick">
            <slot></slot>
        </button>
 

</template>

<script>
    import Utility from '@/Common/Utility'
    import AuthorizeService from '@/Common/AuthorizeService'
    import TControlBase from '@/Common/TControlBase';

    export default {
        data() {
            return {
                m_Value: "",
                 
                m_FunctionEditable: true,

                m_Attribute: TControlBase.Attribute( {
                                Nullable: false,
                                Enabled: true,
                                Visible: true,
                                ReadOnly: false,
                                MaxLength: null
                        }
                )
            };
        }
        ,
        //props: ["value", "text", "nullable","disabled", "Enabled", "Attribute","ConfirmText","Name","FunctionId"],

        props: ["text", "ConfirmText", "FunctionId", ...TControlBase.BaseProps],

        computed: {
             


        }
        ,

        methods: {


            OnAuthChanged() {



                if (this.FunctionId != null) {
                    let auth;

                    if (this.$parent.Action == "CreateVersion") {
                        return;
                    }


                    auth = AuthorizeService.GetFunctionAuth(this.FunctionId);

                    if (auth != null && auth.EditAuth == 0) {
                        this.m_FunctionEditable = false;
                    }
                    else {
                        this.m_FunctionEditable = true;
                    }

                    if (!this.m_FunctionEditable) {
                        this.m_Attribute.Enabled = false;
                    }


                    this.$forceUpdate();
                }

               

            },

            OnButtonClick(e) {
                if (this.ConfirmText != null && this.ConfirmText != "") {
                    Utility.Confirm(this, this.ConfirmText,
                        () => {
                            this.$emit("click", e);
                        }
                    );
                }
                else {
                    this.$emit("click", e);
                }
            },

            UpdateElementByAttribute() {

            },



        },


        mounted() {
            this.DoOnMounted();
        },

        created() {

 
            TControlBase.call(this);

            //if (this.Attribute != null) {
            //    Utility.SetNotNullAttributes(this, this.m_Attribute, this.Attribute);
            //}


            //if (this.disabled != null) {
            //    if (this.disabled == "true" || this.disabled == true) {
            //        this.m_Attribute.Enabled = false;
            //    }
            //    else {
            //        this.m_Attribute.Enabled = true;
            //    }
            //}

            //if (this.Enabled != null) {
            //    if (this.Enabled == "true" || this.Enabled == true) {
            //        this.m_Attribute.Enabled = true;
            //    }
            //    else if (this.Enabled == "false" || this.Enabled == false) {
            //        this.m_Attribute.Enabled = false;
            //    }
            //}
 
            this.OnAuthChanged();

            this.$bus.$on("AuthChanged", this.OnAuthChanged);
            
        },

        watch: {

            FunctionId(newVal) {

                 if (newVal!= null) {
                    let auth;

                    auth = AuthorizeService.GetFunctionAuth(newVal);

                    if (auth != null && auth.EditAuth == 0) {
                        this.m_FunctionEditable = false;
                    }
                    else {
                        this.m_FunctionEditable = true;
                     }

                     if (!this.m_FunctionEditable) {
                         this.m_Attribute.Enabled = false;
                     }


                }

                this.$forceUpdate();
            },

            //Enabled(newVal) {
            //    if (newVal == "true" || newVal == true) {
            //        this.m_Attribute.Enabled = true;
            //    }
            //    else {
            //        this.m_Attribute.Enabled = false;
            //    }

            //    if (this.FunctionId != null) {
            //        let auth;

            //        auth = AuthorizeService.GetFunctionAuth(this.FunctionId);

            //        if (auth != null && auth.EditAuth == 0) {
            //            this.m_FunctionEditable = false;
            //        }
            //        else {
            //            this.m_FunctionEditable = true;
            //        }
            //    }

            //    if (!this.m_FunctionEditable) {
            //        this.m_Attribute.Enabled = false;
            //    }

            //} ,

            //"Attribute.Enabled": function (newVal, oldVal) {
                
            //    this.m_Attribute.Enabled = newVal;
            //},

            //Attribute: function (newVal, oldVal) {
                
            //    Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);

            //    if (this.FunctionId != null) {
            //        let auth;

            //        auth = AuthorizeService.GetFunctionAuth(this.FunctionId);

            //        if (auth != null && auth.EditAuth == 0) {
            //            this.m_FunctionEditable = false;
            //        }
            //        else {
            //            this.m_FunctionEditable = true;
            //        }
            //    }

            //    if (!this.m_FunctionEditable) {
            //        this.m_Attribute.Enabled = false;
            //    }
            //},

            //nullable: function (newVal, oldVal) {
            //},


            disabled: function (newVal, oldVal) {

                if (this.disabled != null) {
                    if (this.disabled == "true" || this.disabled == true) {
                        this.m_Attribute.Enabled = false;
                    }
                    else {
                        this.m_Attribute.Enabled = true;
                    }
                }

                //if (this.Enabled != null) {
                //    if (this.Enabled == "true" || this.Enabled == true) {
                //        this.m_Attribute.Enabled = true;
                //    }
                //    else if (this.Enabled == "false" || this.Enabled == false) {
                //        this.m_Attribute.Enabled = false;
                //    }
                //}

                this.OnAuthChanged();
            },


        }


    }
</script>

<style>
</style>
